import { Card as BaseCard } from 'antd';
import styled, { css } from 'styled-components';

import { COLOR } from 'styles/styledComponents/color.model';

export type Props = { $height?: string; $justify?: 'center'; $margin?: string; $padding?: string };

const cardStyle = css<Props>`
  border-radius: 8px;
  display: flex;
  justify-content: ${({ $justify }) => $justify || 'initial'};
  height: ${({ $height }) => $height || 'auto'};
  width: 100%;
  margin: ${({ $margin }) => $margin || 'auto'};
  font-weight: 600;
  .ant-card-body {
    flex: 1 1 0%;
    padding: ${({ $padding }) => $padding || '2rem'};
  }
`;

export const BasicCard = styled(BaseCard)`
  ${cardStyle}
`;

const customCardStyle = css<Props>`
  align-items: center;
  padding: 1.5rem;
  gap: 0.25rem;
`;

export const SuccessCard = styled.div`
  ${cardStyle};
  ${customCardStyle};
  background-color: ${COLOR.HONEYDEW};
  border: 1px solid ${COLOR.EMERALD};
  color: ${COLOR.GO_GREEN};
`;

export const WarningCard = styled.div`
  ${cardStyle};
  ${customCardStyle};
  background-color: ${COLOR.FLORAL_WHITE};
  border: 1px solid ${COLOR.TOPAZ};
`;

export const ErrorCard = styled.div`
  ${cardStyle};
  ${customCardStyle};
  background-color: ${COLOR.SEASHELL};
  border: 1px solid ${COLOR.VENETIAN_RED};
`;
